import React, { useState } from 'react';
import tw, { styled } from 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import fetch from 'isomorphic-fetch';
import { MusicNotes } from '../../icons';
import { Button, H1 } from '../../styles/shared-styled-components';
import { Modal } from '../../ui/Modal';

const BgGradient = styled.section`
  background-image: linear-gradient(
    to top left,
    #1db954 20%,
    #2f8cdf 40%,
    #56f 60%,
    #780ea7 100%
  );
  ${tw`relative w-screen px-4 sm:px-6 pt-32 pb-12 md:pt-40 md:pb-20 flex justify-center items-center flex-col text-center h-screen`};
`;

const RightArrowIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z"
      fillRule="nonzero"
    />
  </svg>
);

export const HeroHome = () => {
  const [success, setSuccess] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const { handleSubmit, register } = useForm({
    resolver: yupResolver(yup.object().shape({ email: yup.string().email() })),
  });

  const onSubmit = async ({ email }) => {
    const url = 'https://api.sendinblue.com/v3/contacts';
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'api-key': process.env.GATSBY_SIB_SECRET!,
      },
      body: JSON.stringify({ updateEnabled: false, email }),
    };

    const response = await fetch(url, options);
    const data = await response.json();
    if (data.id) {
      setSuccess(true);
    }
  };

  return (
    <BgGradient tw="text-gray-100">
      <div data-aos="zoom-y-out" tw="w-24 h-24 sm:w-32 sm:h-32 mb-8 sm:mb-16">
        <StaticImage
          src="../../assets/images/logo1100.png"
          alt="Listening to music"
        />
      </div>
      <H1
        tw="text-5xl sm:text-6xl font-extrabold leading-tighter tracking-tighter mb-4"
        data-aos="zoom-y-out"
      >
        Playflow
      </H1>
      <div tw="max-w-3xl mx-auto">
        <h2
          tw="font-medium text-xl sm:text-2xl md:text-3xl mb-6"
          data-aos="zoom-y-out"
          data-aos-delay="150"
        >
          "Spotify Radio on steroids"
          <br />
          Explore your favourite songs with fresh eyes.
        </h2>
        <h3 tw="text-lg sm:text-xl md:text-2xl mb-12 font-black underline">
          App invites are first-come-first-serve. Put down your email to join
          the waitlist
        </h3>
        {success && (
          <p tw="text-lg mt-6 text-white">
            Thank you. You're now on the waiting list!
          </p>
        )}
        <div
          tw="max-w-xs mx-auto text-xl sm:max-w-none sm:flex sm:justify-center"
          data-aos="zoom-y-out"
          data-aos-delay="300"
        >
          <form
            onSubmit={handleSubmit(onSubmit)}
            tw="flex flex-col items-center sm:flex-row"
          >
            <input
              tw="text-black rounded min-w-max h-full px-4 py-4 sm:py-2 mb-4 sm:mb-0 md:py-6 md:px-4 shadow focus:shadow-2xl"
              id="beta"
              type="email"
              placeholder="Your email"
              required
              {...register('email')}
            />
            <Button
              small
              type="submit"
              className={
                'ml-4 text-black font-bold rounded-lg py-4 px-2 md:py-6 md:px-4 shadow-md hover:shadow-2xl transition ease-in-out' +
                (success ? ' bg-gray-100' : ' bg-teal-400')
              }
              href="#0"
            >
              Keep me posted!
              <span tw="ml-2 fill-current w-4 h-4">
                <RightArrowIcon />
              </span>
            </Button>
          </form>
        </div>
      </div>
    </BgGradient>
  );
};
